import React, { Component } from 'react'

export class Cycle extends Component {
	render() {
		return (
			<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_1649_946)">
					<path opacity="0.1" fillRule="evenodd" clipRule="evenodd" d="M32 10.6666C26.3421 10.6666
					20.9159 12.9142 16.9151 16.915C12.9143 20.9157 10.6667 26.342 10.6667 31.9999C10.6667 37.6579
					12.9143 43.0841 16.9151 47.0849C20.9159 51.0856 26.3421 53.3332 32 53.3332C37.658 53.3332 43.0842
					51.0856 47.085 47.0849C51.0858 43.0841 53.3334 37.6579 53.3334 31.9999C53.3334 26.342 51.0858 20.9157
					47.085 16.915C43.0842 12.9142 37.658 10.6666 32 10.6666ZM5.33337 31.9999C5.33337 17.2719 17.272 5.33325
					32 5.33325C46.728 5.33325 58.6667 17.2719 58.6667 31.9999C58.6667 46.7279 46.728 58.6666 32
					58.6666C17.272 58.6666 5.33337 46.7279 5.33337 31.9999Z" fill="black" />
					<path fillRule="evenodd" clipRule="evenodd" d="M32 10.6666C26.4998 10.655 21.2098 12.7794
					17.2454 16.592C16.9925 16.8343 16.6944 17.0245 16.3681 17.1516C16.0418 17.2787 15.6936 17.3403
					15.3434 17.3329C14.9933 17.3255 14.6481 17.2491 14.3274 17.1083C14.0068 16.9674 13.717 16.7648
					13.4747 16.512C13.2324 16.2591 13.0422 15.961 12.9151 15.6347C12.7879 15.3084 12.7263 14.9602
					12.7338 14.6101C12.7412 14.2599 12.8175 13.9147 12.9584 13.594C13.0992 13.2734 13.3018 12.9836
					13.5547 12.7413C18.5122 7.97711 25.1244 5.32153 32 5.33329C32.7073 5.33329 33.3855 5.61424 33.8856
					6.11434C34.3857 6.61444 34.6667 7.29271 34.6667 7.99996C34.6667 8.7072 34.3857 9.38548 33.8856
					9.88558C33.3855 10.3857 32.7073 10.6666 32 10.6666Z" fill="#00528A" />
				</g>
				<defs>
					<clipPath id="clip0_1649_946">
						<rect width="64" height="64" fill="white" />
					</clipPath>
				</defs>
			</svg>


		)
	}
}

export default Cycle
